import { CommandChannel } from '@zoom/videosdk'

export const notifyToMyTeam = async ({
    message,
    commandChannel,
}: {
    message: Record<string, unknown>
    commandChannel: typeof CommandChannel | null
}) => {
    if (!message || !commandChannel) return false
    try {
        // Send to all participants (no userId means broadcast)
        await commandChannel.send(JSON.stringify(message))
        return true
    } catch (error) {
        console.error('Failed to send help request message:', error)
        return false
    }
}
